"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepartmentBelongingType = void 0;
exports.DepartmentBelongingType = {
    NORMAL: 1,
    BOSS: 2,
};
